import React from 'react';
import { Layout } from '../../components/Layout';
import { Checklist } from '../../components/Checklist';
import { Button } from '../../components/ui/Button';
import { Card } from '../../components/ui/Card';
import { Smartphone, ShieldAlert, ArrowRight, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';
const LOST_DEVICE_CHECKLIST = ['Activate Lost Mode / Remote Lock', 'Initiate Remote Wipe (if sensitive)', 'Revoke device access from accounts', 'Change passwords for logged-in apps', 'Report to carrier (block IMEI/SIM)'];
export function LostDevice() {
  return <Layout data-id="element-3762">
      <div className="container mx-auto px-4 py-12" data-id="element-3763">
        <div className="mb-12 border-b border-slate-800 pb-8" data-id="element-3764">
          <div className="inline-flex items-center px-3 py-1 rounded-full bg-red-500/10 text-red-400 text-xs font-medium mb-4 border border-red-500/20" data-id="element-3765">
            <ShieldAlert className="h-3 w-3 mr-2" data-id="element-3766" />
            Incident Response Playbook
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-slate-100 mb-4" data-id="element-3767">
            Lost or Stolen Device
          </h1>
          <p className="text-xl text-slate-400 max-w-3xl" data-id="element-3768">
            Quick steps when your phone or laptop is lost to prevent data theft.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-3769">
          <div className="lg:col-span-2 space-y-12" data-id="element-3770">
            <section data-id="element-3771">
              <h2 className="text-2xl font-bold text-slate-100 mb-6 flex items-center" data-id="element-3772">
                <MapPin className="h-6 w-6 text-red-500 mr-3" data-id="element-3773" />
                Immediate Actions
              </h2>
              <div className="space-y-6" data-id="element-3774">
                <div className="bg-slate-900/50 p-6 rounded-lg border-l-4 border-red-500" data-id="element-3775">
                  <h3 className="text-xl font-bold text-slate-100 mb-2" data-id="element-3776">
                    1. Remote Lock & Wipe
                  </h3>
                  <p className="text-slate-400 mb-4" data-id="element-3777">
                    Use Find My (iOS/Android/Windows) feature immediately.
                  </p>
                  <ul className="list-disc list-inside text-slate-300 space-y-1" data-id="element-3778">
                    <li data-id="element-3779">
                      <strong data-id="element-3780">Lost Mode:</strong> Locks screen and displays
                      contact message.
                    </li>
                    <li data-id="element-3781">
                      <strong data-id="element-3782">Remote Wipe:</strong> Erase all data if unlikely
                      to be recovered.
                    </li>
                  </ul>
                </div>

                <div className="bg-slate-900/50 p-6 rounded-lg border-l-4 border-orange-500" data-id="element-3783">
                  <h3 className="text-xl font-bold text-slate-100 mb-2" data-id="element-3784">
                    2. Secure Accounts & SIM
                  </h3>
                  <p className="text-slate-400 mb-4" data-id="element-3785">
                    Thieves may move SIM card to another phone to bypass OTP.
                  </p>
                  <ul className="list-disc list-inside text-slate-300 space-y-1" data-id="element-3786">
                    <li data-id="element-3787">Contact carrier to block number/SIM.</li>
                    <li data-id="element-3788">
                      Force logout (Revoke Access) Google/iCloud/Social Media
                      accounts from that device.
                    </li>
                  </ul>
                </div>
              </div>
            </section>
          </div>

          <div className="space-y-6" data-id="element-3789">
            <Checklist id="ir-lost-checklist" title="Response Checklist" items={LOST_DEVICE_CHECKLIST} data-id="element-3790" />
            <Card className="p-6 bg-slate-900/50 border-slate-800" data-id="element-3791">
              <h3 className="font-bold text-slate-100 mb-4" data-id="element-3792">
                Related Playbooks
              </h3>
              <div className="space-y-3" data-id="element-3793">
                <Link to="/ir/account-takeover" data-id="element-3794">
                  <Button variant="secondary" fullWidth className="justify-between group" data-id="element-3795">
                    Account Takeover
                    <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" data-id="element-3796" />
                  </Button>
                </Link>
                <Link to="/devices/ios" data-id="element-3797">
                  <Button variant="secondary" fullWidth className="justify-between group" data-id="element-3798">
                    Prevent: iOS Security
                    <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" data-id="element-3799" />
                  </Button>
                </Link>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </Layout>;
}